<template>
  <div
    class="room-card"
    :class="{
      'for-male': forMale,
      'for-female': forFemale,
      '-disabled': disabled
    }"
  >
    <div class="room-card__top">
      <img :src="image" alt="" class="room-card__img" v-if="image" />
      <img
        src="@/assets/img/building.png"
        alt=""
        class="room-card__img"
        v-else
      />
    </div>
    <div class="room-card__cnt">
      <div class="room-card__content">
        <div class="room-card__title">
          <small class="room-card__subtitle">{{ location }}</small>
          <p class="room-card__title-main">{{ title }}</p>
        </div>
        <div class="room-card-price">
          <div class="room-card-price__title">{{ price }} TL</div>
          <div class="room-card-price__txt">
            'den başlayan <br />oda fiyatları
          </div>
        </div>
      </div>
      <div class="room-card__bottom">
        <DormRoomPanelCardFeature
          v-for="(feature, index) in features"
          :key="index"
          :icon="feature.icon"
          :text="feature.text"
          :param="feature.param"
        ></DormRoomPanelCardFeature>
      </div>
    </div>
    <div class="room-card__actions">
      <v-button
        size="xs"
        class="room-card-button-third btn-block"
        title="Rezerveleri Gör"
        @click="$emit('reservation')"
        :disabled="disabled"
      ></v-button>
      <v-button
        size="xs"
        class="room-card-button-primary"
        title="Düzenle"
        @click="$emit('edit')"
        :disabled="disabled"
      ></v-button>
      <v-button
        size="xs"
        class="room-card-button-secondary"
        title="Sil"
        @click="$emit('delete')"
        :disabled="disabled"
      ></v-button>
    </div>
  </div>
</template>

<script>
import DormRoomPanelCardFeature from './DormRoomPanelCardFeature.vue'

export default {
  emits: ['edit', 'delete'],
  props: {
    cover: {
      type: String,
      required: true
    },
    images: {
      type: Array,
      default: () => []
    },
    location: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    price: {
      type: Number || String,
      required: true
    },
    isActive: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    capacity: Number || String,
    meal: Number || String,
    forMale: Boolean,
    forFemale: Boolean
  },
  computed: {
    features() {
      return [
        {
          icon: 'icon-bed',
          text: 'Kişilik',
          param: this.capacity,
          condition: this.capacity != null
        },
        {
          icon: 'icon-food',
          text: 'Öğün',
          param: this.meal,
          condition: this.meal != null
        }
      ].filter(i => i.condition)
    },
    image() {
      if (this.images.length <= 0) return this.cover
      return this.images[0].filename
    }
  },
  components: { DormRoomPanelCardFeature }
}
</script>

<style lang="scss" scoped>
@import '../../assets/scss/components/dorm-room-card';
</style>
